/**
 * @generated SignedSource<<7ce85db8a0c5aa10d8bb0cf780a8445d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotifyAboutJob_User$data = {
  readonly firstName: string | null | undefined;
  readonly profile: {
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly rawId: number | null | undefined;
  readonly " $fragmentType": "NotifyAboutJob_User";
};
export type NotifyAboutJob_User$key = {
  readonly " $data"?: NotifyAboutJob_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotifyAboutJob_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotifyAboutJob_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "dc83929709a1ecc80bb7123c90790f84";

export default node;
